import { useEffect } from 'react';
import { useNotifications } from '../../notifications/hooks/useNotifications';
import { waiting_room_model } from '../../models/waiting_room_model';
import { useApp } from 'xAppLib/Hooks';
const NOTIFICATION_KEY = 'need_review';

export const useScriptsNeedReview = () => {
    const { setDynamicNotification, removeDynamicNotification } = useNotifications();
    const app = useApp();

    useEffect(() => {
        if (!app?.acl?.can_manual_review || app?.settings?.icosm) return;
        
        return waiting_room_model.watch_need_review(recs => {
            const scriptsCount = Object.values(recs || {}).length;

            
            if (scriptsCount > 0) {
                const text = `${scriptsCount} script${scriptsCount > 1 ? 's' : ''} requiring manual review`
                setDynamicNotification(NOTIFICATION_KEY, {
                    type: NOTIFICATION_KEY,
                    title: text,
                    icon: 'map signs',
                    link: '/scripts/list/need_review',
                    overrides: {
                        banner: true,
                        banner_grid: true,
                        banner_variant: 'warning',
                    },
                });
            } else {
                removeDynamicNotification(NOTIFICATION_KEY);
            }
        });
    }, [app?.acl?.can_manual_review || app?.settings?.icosm]);
}
